import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: "/content/:ch/:page",
      name: "content",
      component: () => import('@/components/content.vue'),
    },
    {
      path: "/personnel.html",
      name: "personnel",
      component: () => import('@/components/personnel.vue'),
    },
    {
      path: "/about.html",
      name: "about",
      component: () => import('@/components/about.vue'),
    },
    {
      path: "/article/:ch/:id",
      name: "article",
      component: () => import('@/components/article.vue'),
    },
    {
      path: "/support.html",
      name: "support",
      component: () => import('@/components/support.vue'),
    },
    {
      path: "/cp.html",
      name: "cp",
      component: () => import('@/components/cp.vue'),
    },
    {
      path: "/example.html",
      name: "example",
      component: () => import('@/components/example.vue'),
    },
    {
      path: "/application.html",
      name: "application",
      component: () => import('@/components/application.vue'),
    },
    {
      path: "/develop.html",
      name: "develop",
      component: () => import('@/components/develop.vue'),
    },
    {
      path: "/city.html",
      name: "city",
      component: () => import('@/components/city.vue'),
    },
    {
      path: "/bigdata.html",
      name: "bigdata",
      component: () => import('@/components/bigdata.vue'),
    },
    {
      path: "/news.html",
      name: "news",
      component: () => import('@/components/news.vue'),
    },
    {
      path: "/products.html",
      name: "products",
      component: () => import('@/components/products.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js